import { render, staticRenderFns } from "./organizing-committee.vue?vue&type=template&id=7dfea6be&scoped=true&"
import script from "./organizing-committee.vue?vue&type=script&lang=js&"
export * from "./organizing-committee.vue?vue&type=script&lang=js&"
import style0 from "./organizing-committee.vue?vue&type=style&index=0&id=7dfea6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfea6be",
  null
  
)

export default component.exports